export function getIdKey(isUniqueId) {
  return isUniqueId ? 'unique_id' : 'id';
}
